import axios from "axios";

import history from "../history";
import store from "../store"
import { login } from "../actions/authActions";
import errorHandler from "../helpers/errorHandler";

const backend = axios.create({
    baseURL: process.env.REACT_APP_BACKEND_ORIGIN,
    withCredentials: true
});

export default backend;

export const sessionCheck = redirect => {
    return new Promise((resolve, reject) => {
        backend.get("/api/auth/", {
            headers: {
                "Authorization": `Bearer ${store.getState().auth.token || ""}`
            }
        })
        .then(response => {
            if (response.data.token) {
                store.dispatch(login(response.data.token, response.data.userID));
                if (redirect) {
                    reject();
                    history.push("/");
                }
                else resolve();
    
            } else {
                if (!redirect) {
                    reject();
                    history.push("/login");
                }
                else resolve();
            }
        })
        .catch(error => {
            reject();
            errorHandler(error, null);
        });
    });
};

export const tokenCheck = token => {
    return new Promise((resolve, reject) => {
        backend.get(`/api/requests/check/from/${token}`)
        .then(response => {
            if (response.data.status === 200) resolve();
            else reject(response.data.json.error[0].message);
        })
        .catch(error => {
            errorHandler(error, null);
        });
    });
};

export const recursiveRequest = async (request, maxTry = 3) => {
    if (maxTry > 0) {
        const response = await request();

        if (response.status === 202 && response.data.token) {
            store.dispatch(login(response.data.token, response.data.userID));
            return await recursiveRequest(request, maxTry - 1);
        }
        else if (response.status === 200 && !response.data.token) return response;
        else history.go(0);
    }
    else history.go(0);
};